var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.messages.length)?_c('div',{staticClass:"app-messages_am",class:( _obj = {}, _obj[("am_" + _vm.mode)] = true, _obj )},_vm._l((_vm.messages),function(m,i){return _c('div',{key:("app-message-" + i),staticClass:"am_message"},[_vm._v("\n    "+_vm._s(m)+"\n  ")])})):_vm._e()
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5af56ba2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppMessages.vue
// module id = null
// module chunks = 